import { boot } from "quasar/wrappers";
import { defineComponent, h } from "vue";
import VueGoogleMaps from "@fawmi/vue-google-maps";
import { getGoogleMapsApiKey } from "src/utils/googleMaps";

function createGoogleMapStubComponent(name, renderContent) {
  return defineComponent({
    name,
    inheritAttrs: false,
    emits: ["click"],
    setup(_props, { attrs, emit, slots }) {
      return () =>
        h(
          "div",
          {
            ...attrs,
            class: [attrs.class, `google-maps-stub ${name}`],
            "data-testid":
              name === "GMapMap"
                ? "google-map-runtime-stub"
                : "google-map-marker-runtime-stub",
            onClick: (event) => {
              if (typeof attrs.onClick === "function") {
                attrs.onClick(event);
              }
              emit("click", {
                latLng: {
                  lat: () => 0,
                  lng: () => 0,
                },
              });
            },
          },
          renderContent(slots)
        );
    },
  });
}

function registerGoogleMapRuntimeStubs(app) {
  app.component(
    "GMapMap",
    createGoogleMapStubComponent("GMapMap", (slots) =>
      slots.default ? slots.default() : []
    )
  );
  app.component(
    "GMapMarker",
    createGoogleMapStubComponent("GMapMarker", () => [])
  );
  app.component(
    "GMapPolygon",
    createGoogleMapStubComponent("GMapPolygon", () => [])
  );
}

export function shouldUseGoogleMapRuntimeStub(apiKey) {
  if (
    typeof window !== "undefined" &&
    window.__E2E_GOOGLE_MAPS_MOCKED__ === true
  ) {
    return true;
  }
  if (typeof process !== "undefined" && process.env?.NODE_ENV === "test") {
    return true;
  }
  return !apiKey;
}

export default boot(({ app }) => {
  const apiKey = getGoogleMapsApiKey();

  if (shouldUseGoogleMapRuntimeStub(apiKey)) {
    registerGoogleMapRuntimeStubs(app);
    console.warn("Google Maps runtime stub enabled for test/QA mode.");
    return;
  }

  if (!apiKey) {
    console.warn(
      "Google Maps API key missing. Set VUE_APP_GOOGLE_MAPS_KEY (or VITE_GOOGLE_MAPS_KEY) to enable maps."
    );
    return;
  }

  app.use(VueGoogleMaps, {
    load: {
      key: apiKey,
      v: "weekly",
      loading: "async",
    },
  });
});
